<template>
  <v-main style="height: 100%">
    <v-col cols="12" class="text-center pa-4"> <!-- Added pa-4 for padding -->
      <v-avatar size="127" class="mx-auto">
        <img
          :src="empImage"
        />
      </v-avatar>
      <h3 class="font-weight-bold mt-4" v-if="dataBooking.length > 0">{{ dataBooking[0].empFull_NameTH }}</h3>
      <v-row class="mt-2 px-1" v-if="dataBooking.length > 0">
        <v-col cols="12" class="text-left">
          <v-list-item>
            <v-list-item-content>
              <p class="mb-2"><strong>ชื่อลูกค้า {{ dataBooking[0].bookingDataCustomerName }}</strong></p>
              <p class="mb-2"><strong>บริการ {{ dataBooking[0].flowName }}</strong></p>

              <v-list-item-title class="mb-2 d-flex align-center"> <!-- Added d-flex and align-center -->
                <v-icon class="mr-2" color="#F38383">mdi-home</v-icon>
                <div class="address-text">{{ dataBooking[0].address }}</div>
              </v-list-item-title>

              <v-list-item-title class="mb-2"> <!-- Added mb-2 for bottom margin -->
                <v-icon class="mr-2" color="#F38383">mdi-map-marker</v-icon>
                {{ fieldValue }}
              </v-list-item-title>

              <v-list-item-title class="mb-2"> <!-- Added mb-2 for bottom margin -->
                <v-icon class="mr-2" color="green">mdi-phone</v-icon>
                {{ phonNumber }}
              </v-list-item-title>

              <v-list-item-title class="mb-2"> <!-- Added mb-2 for bottom margin -->
                <v-icon class="mr-2" color="#F38383">mdi-clock</v-icon>
                {{ formatDateToThai() }}
              </v-list-item-title>

              <v-list-item-title> <!-- No margin needed for the last item -->
                <v-icon class="ps-8"></v-icon>
                เวลานัด&nbsp;&nbsp;&nbsp;{{dataBooking[0].timeText}}&nbsp;&nbsp;เวลาจบงาน&nbsp;&nbsp;&nbsp;{{ Finishingtime }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row class="ma-2 px-2">
        <v-col cols="12" class="text-left">
          <h5 class="font-weight-bold">ประเมินความพึงพอใจ</h5>
          <v-form v-for="(item, index) in AlldataRating" :key="item.id">
            <p>{{ index+1 }}. {{ item.answer }}</p>
            <v-rating :length="item.rating"  v-model="ratings[index]" color="yellow" large></v-rating>
          </v-form>
          <v-textarea label="ข้อเสนอแนะ" v-model="comment" outlined class="mt-4"></v-textarea>
        </v-col>
      </v-row>

      <!-- Submit Button -->
      <v-row class="ma-2">
        <v-col cols="12" class="text-center">
          <v-btn
            rounded
            color="indigo"
            dark
            class="mx-auto"
            large
            block
            @click="submitForm">
            ปิดงาน
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-main>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import 'moment/locale/th' // ตั้งค่าให้ Moment.js ใช้ภาษาไทย

export default {
  data () {
    return {
      dialog: false,
      dialogMessage: '', // Message to show in the dialog
      ratings: [],
      comment: '',
      shopId: '',
      jobNo: '',
      bookNo: '',
      typeWork: '',
      fieldValue: '',
      masBranchID: '',
      dataBooking: [],
      dataRating: [],
      AlldataRating: [],
      Finishingtime: '',
      phonNumber: '',
      dataAllJob: [],
      status: [],
      empImage: '',
      profile: []
    }
  },
  async mounted () {
    this.shopId = this.$route.query.shopId
    this.jobNo = this.$route.query.jobNo
    this.typeWork = this.$route.query.typeWork
    await this.getLog()
    console.log(this.shopId, this.jobNo, this.typeWork)
    await this.getBookingDetails()
    await this.getDataRating()
    await this.getJob()
    await this.getImage()
    let dataLineConfig = await this.getDataLineConfig(this.shopId)
    await this.checkLiffLogin(dataLineConfig)
    // await this.getProfile()
  },
  methods: {
    async getLog () {
      const response = await axios.get(`${this.DNS_IP}/rating/get?refId=${this.jobNo}`)
      const chk = response.data.length || 0
      if (chk) {
        this.$swal('', 'ให้คะแนนแล้ว', 'success').then(result => {
          this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=ratingDuplicate')
        }).catch((error) => {
          console.log('error function addData : ', error)
          this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=ratingNoData')
        })
      }
    },
    async checkLiffLogin (dataLineConfig) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        }).then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({redirectUri: window.location.href})
            } else {
              await this.getProfile()
            }
          }
        }).catch((err) => {
        // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getProfile () {
      let _this = this
      await this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
        console.log('prod', _this.profile)
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    async submitForm () {
      const response = await axios.get(`${this.DNS_IP}/rating/get?refId=${this.jobNo}`)
      const chk = response.data.length || 0
      if (chk === 0) {
      // Filter out duplicate entries from this.dataAllJob
        const uniqueJobs = this.dataAllJob.filter((job, index, allJobs) =>
          index === allJobs.findIndex((t) => t.id === job.id)
        )

        console.log('Unique jobs:', uniqueJobs)

        // Get the employee ID from the first unique job or set it to null if none exist
        const empId = uniqueJobs.length > 0 ? uniqueJobs[0].empId : null

        // Validation: Check if all ratings are non-zero and comment is not empty
        if (this.ratings.some(rating => rating === 0) || !this.comment) {
        // Show error message with SweetAlert
          await this.$swal('มีข้อผิดพลาด', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
          return // Stop further execution
        }

        // Prepare an array to hold multiple request payloads
        const requestPayloads = []

        // Check if ratings is not empty and is of type array
        if (this.ratings && this.ratings.length > 0) {
        // Ensure dataRating is an array, wrapping it if necessary
          let answerIds
          if (this.AlldataRating && typeof this.AlldataRating === 'object' && this.AlldataRating.constructor === Array) {
            answerIds = this.AlldataRating // Use as is if it's an array
          } else {
            answerIds = [this.AlldataRating] // Wrap it in an array if it's not
          }

          // Fill answerIds to match the length of ratings
          while (answerIds.length < this.ratings.length) {
            answerIds.push(answerIds[0]) // Repeat the first element to fill the array
          }

          // Create request payloads for each rating
          this.ratings.forEach((rating, index) => {
            const payload = {
              refId: this.jobNo,
              comment: this.comment,
              typeWork: this.typeWork,
              shopId: this.shopId,
              empId: empId,
              answerId: answerIds[index].id, // Assign the corresponding answerId
              rating: rating, // Assign the current rating
              pictureUrl: this.profile.pictureUrl,
              displayName: this.profile.displayName
            }
            requestPayloads.push(payload) // Add the payload to the array
          })
        }

        console.log('Items to send:', requestPayloads)

        try {
          for (const payload of requestPayloads) {
            const response = await axios.post(`${this.DNS_IP}/rating/add`, payload)
            console.log('Response for answerId:', payload, response.data)
            this.status.push(response.data)
          }
          let allTrue = true

          for (const item of this.status) {
            if (!item.status) {
              allTrue = false
              break // หยุดการวน loop ถ้าพบค่า false
            }
          }

          if (allTrue) {
            this.$swal('ประเมินสำเร็จ', '', 'success')
            this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=ratingDuplicate')
          } else {
            this.$swal('มีข้อผิดพลาด', '', 'warning')
            this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=ratingNoData')
          }
        } catch (error) {
          console.error('Error:', error.response ? error.response.data : error.message)
        }
      } else {
        this.$swal('', 'ให้คะแนนแล้ว', 'success').then(result => {
          this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=ratingDuplicate')
        }).catch((error) => {
          console.log('error function addData : ', error)
          this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=ratingNoData')
        })
      }
    },
    formatPhoneNumber (phoneNumber) {
      if (!phoneNumber) return ''
      // Remove any dashes from the phone number and add a space after the first three digits
      return phoneNumber.replace(/-/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')
    },
    async getBookingDetails () {
      try {
        // Fetch booking data
        const response = await axios.get(
          `${this.DNS_IP}/booking_view/get?shopId=${this.shopId}&jobNo=${this.jobNo}`
        )
        console.log(response.data)

        // Assign the fetched data to your component data
        this.dataBooking = response.data
        console.log('this.formatPhoneNumber(this.dataBooking[0].bookingDataCustomerTel) ', this.formatPhoneNumber(this.dataBooking[0].bookingDataCustomerTel))
        await this.formatDateToThai(this.dataBooking[0].dueDateDay)
        this.phonNumber = this.formatPhoneNumber(this.dataBooking[0].bookingDataCustomerTel)

        // Check if there is data before proceeding
        if (this.dataBooking.length > 0) {
          this.bookNo = this.dataBooking[0].bookNo
          console.log('bookNo', this.bookNo)

          // Fetch booking details using bookNo
          const bookingDataResponse = await axios.get(
            `${this.DNS_IP}/BookingData/get?shopId=${this.shopId}&bookNo=${this.bookNo}`
          )

          const bookingData = bookingDataResponse.data

          // Find the fieldName that matches the condition
          const destination = bookingData.find(item => item.fieldName === 'จุดหมายปลายทาง')

          // Check if the fieldValue exists
          this.fieldValue = destination ? destination.fieldValue : null
          console.log('fieldValue', this.fieldValue)
        } else {
          console.log('No booking data found.')
        }
      } catch (error) {
        console.error('Error fetching booking details:', error)
      }
    },
    async getDataRating () {
      console.log('Id', this.dataBooking)
      const masBranchID = this.dataBooking[0].masBranchID
      const flowId = this.dataBooking[0].flowId.toString()
      console.log('Branch ID:', masBranchID)
      console.log('Flow ID:', flowId)

      try {
        // Initialize AlldataRating to store the results
        this.AlldataRating = []

        // Fetch the data only once
        const response = await axios.get(
          `${this.DNS_IP}/ratingformat/get?shopId=${this.shopId}&masBranchID=${masBranchID}`
        )
        console.log(response.data)

        this.dataRating = response.data
        console.log('this.dataRating', this.dataRating)

        // Loop through dataRating and check flowId or 'All'
        for (let i = 0; i < this.dataRating.length; i++) {
          console.log('Checking flowId:', this.dataRating[i].flowId)

          if (this.dataRating[i].flowId === flowId) {
            console.log('Matched specific flowId:', this.dataRating[i].flowId, flowId)

            // Store the matched data in AlldataRating
            this.AlldataRating.push(this.dataRating[i])
          } else if (this.dataRating[i].flowId === 'All') {
            console.log('Matched flowId: All')

            // Store the 'All' data in AlldataRating
            this.AlldataRating.push(this.dataRating[i])
          }
        }

        // Log the final collected AlldataRating
        console.log('this.AlldataRating:', this.AlldataRating)
      } catch (error) {
        console.error('Error fetching rating data:', error)
      }
    },
    formatDateToThai (dateString) {
      const date = moment(dateString)

      const daysOfWeek = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
      const months = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']

      const dayOfWeek = daysOfWeek[date.day()]
      const dayOfMonth = date.date()
      const month = months[date.month()]
      const year = date.year() + 543

      return `วัน${dayOfWeek}ที่ ${dayOfMonth} ${month} ${year}`
    },
    async getJob () {
      try {
        const response = await axios.get(
          `${this.DNS_IP}/job/getRating?jobNo=${this.jobNo}`
        )

        // ตรวจสอบค่า LAST_DATE_TIME ไม่ให้ซ้ำและเก็บค่าแรกที่ไม่ซ้ำใน Finishingtime
        const uniqueDates = new Set() // ใช้ Set เพื่อเก็บค่าที่ไม่ซ้ำ

        for (const item of response.data) {
          if (!uniqueDates.has(item.LAST_DATE_TIME)) {
            uniqueDates.add(item.LAST_DATE_TIME)
            this.Finishingtime = item.LAST_DATE_TIME // เก็บค่าแรกที่ไม่ซ้ำลงใน Finishingtime
            break // ออกจาก loop เมื่อเจอค่าแรกที่ไม่ซ้ำ
          }
        }
        this.dataAllJob = response.data
      } catch (error) {
        console.error('Error fetching job:', error)
      }
    },
    async getImage () {
      // Filter out duplicate entries from this.dataAllJob
      const uniqueJobs = this.dataAllJob.filter((job, index, allJobs) =>
        index === allJobs.findIndex((t) => t.id === job.id)
      )

      console.log('Unique jobs:', uniqueJobs)

      // Get the employee ID from the first unique job or set it to null if none exist
      const empId = uniqueJobs.length > 0 ? uniqueJobs[0].empId : null
      try {
        const response = await axios.get(
          `${this.DNS_IP}/empSelect/get?empId=${empId}`
        )
        this.empImage = response.data[0].empImge // Use optional chaining to avoid errors if data is missing
        console.log('data image ', this.empImage)

        // Retry fetching image if this.empImage is null or undefined
        if (!this.empImage) {
          const retryResponse = await axios.get(
            `${this.DNS_IP}/sys_shop/get?shopId=${this.shopId}`
          )
          this.empImage = retryResponse.data[0].shopImge
          console.log('Retry data image', this.empImage)
        }
      } catch (error) {
        console.error('Error fetching image:', error)
      }
    }
  }
}
</script>

<style scoped>
.address-text {
  display: block; /* Change to block to ensure it takes the full width */
  max-width: 100%; /* Set a max width to control when the break occurs */
  overflow-wrap: break-word; /* Allows long words to break onto the next line */
  white-space: normal; /* Allows the text to wrap onto the next line */
  word-break: break-word; /* Prevents long words from causing overflow */
  margin-top: 4px; /* Optional: add margin for spacing */
}

</style>



// WEBPACK FOOTER //
// src/components/Booking/JoyrideReview.vue